import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WIRELESS_ROUTE } from '@rci/self-serve-fido/app.constant';
import { AccountDetailService } from '@rci/self-serve-fido/state/account/account-detail.service';
import { RoutingService } from '@rogers/self-serve-utils/routing';

@Injectable({
  providedIn: 'root',
})
export class GroupIdOrSubscriberDeeplinkGuard implements CanActivate {
  private readonly accountDetailService = inject(AccountDetailService);
  private readonly routingService = inject(RoutingService);

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.accountDetailService.selectedAccount$.pipe(
      map(accountDetail => {
        if (accountDetail.isSubscriber || accountDetail.isGroupId) {
          this.routingService.navigate(WIRELESS_ROUTE);
          return false;
        }

        return true;
      }),
    );
  }
}
